<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester :keyword="$t('views.g4s.communityactivityapplication.keyword')"></query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>{{$t('views.g4s.communityactivityapplication.syear')}}-{{$t('views.g4s.communityactivityapplication.semester')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.no')}}-{{$t('views.g4s.communityactivityapplication.name')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.date')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.community')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.approovedNm')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.download')}}</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.CommunityActivityApplicationID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.CommunityActivityApplicationID" /></td>
                        <td data-th="學年度-學期">
                            {{item.SYear}}-
                            <template v-if="$i18n.locale==='tw'">
                                {{item.Semester|semester}}
                            </template>
                            <template v-else-if="$i18n.locale==='en'">
                                {{item.SemesterEn}}
                            </template>
                        </td>
                        <td data-th="編號-名稱"><b-button size="sm" variant="link" @click="edit(item.CommunityActivityApplicationID)">{{item.No}}-{{item.Name}}</b-button></td>
                        <td data-th="日期">{{item.StartDay|date('yyyy/mm/dd')}} - {{item.EndDay|date('yyyy/mm/dd')}}</td>
                        <td data-th="社團名稱">
                            <template v-if="$i18n.locale==='tw'">
                                {{item.CommunityNm}}
                            </template>
                            <template v-else-if="$i18n.locale==='en'">
                                {{item.CommunityEnNm}}
                            </template>
                        </td>
                        <td data-th="狀態">
                            <template v-if="$i18n.locale==='tw'">
                                {{item.ApprovedNm}}
                            </template>
                            <template v-else-if="$i18n.locale==='en'">
                                {{item.ApprovedEnNm}}
                            </template>
                            <span v-if="item.Suggestion">-{{item.Suggestion}}</span>
                        </td>
                        <td data-th="下載">
                            <div class="btn btn-info" v-if="item.Approved=='Y'" @click="download(item.CommunityActivityApplicationID)">下載</div>
                            <div class="btn btn-info" v-if="item.Approved=='Y'" @click="downloadEn(item.CommunityActivityApplicationID)">Download</div>
                        </td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
        </Detail>
    </page-main>
</template>

<script>
    import Detail from './communityactivityapplicationDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'communityactivityapplication',
        api: '/api/communityactivityapplication/',
        components: { Detail },
        methods: {
            download: function (id) {
                window.open(this.$apiurl + 'api/communityactivityapplication/Download/' + id);
            },
            downloadEn: function (id) {
                window.open(this.$apiurl + 'api/communityactivityapplication/DownloadEn/' + id);
            }
        }
    });
</script>

<style>
</style>